import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { AddScheduleHourModule } from '../add-schedule-hour/add-schedule-hour.module';
import { ScheduleHoursComponent } from './schedule-hours.component';
import { RegisterModule } from 'src/app/common-components/register/register.module';

@NgModule({
   declarations: [ScheduleHoursComponent],
   exports: [ScheduleHoursComponent],
   imports: [
      DragDropModule,
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      MatIconModule,
      MatTooltipModule,
      MatButtonModule,
      MatCheckboxModule,
      MatMenuModule,
      LcsLoadingOverlayModule,
      RegisterModule,
      LcsResponsiveTableModule,
      ScrollingModule,
      LcsCallStatePipeModule,
      AddScheduleHourModule,
   ],
})
export class ScheduleHoursModule {}
